<script>
const staticImage = 'https://qing-so.cn/images/'
const urlFName = 'https://qing-so.cn/api-admin-gateway/'
const urlImage = 'https://qing-so.cn/api-admin-gateway/fms'
const url = 'https://qing-so.cn/zhwygw/'

/* const urlFName = 'http://58.213.158.66:30030/api-gateway/'
const urlImage = 'http://58.213.158.66:30030/api-gateway/fms'
const url = 'http://58.213.158.66:30030/zhwygw/' */

export default {
  staticImage,
  urlFName,
  urlImage,
  url
}
</script>
